import React, { useEffect, useMemo, useState } from 'react';

import { Cancel, Search } from '@mui/icons-material';
import { MenuItem, Stack, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';

import SiteContractItem from 'Components/TestPackages/SiteContractItem';
import {
  getPartnersFromLS,
  sortAndFilterSiteContracts,
} from 'Components/TestPackages/utils';

const sortTypes = [
  'End date (descending)',
  'End date (ascending)',
  'Start date (descending)',
  'Start date (ascending)',
];

const SiteContractList = ({ siteContracts }) => {
  const [searchTerm, setSearchTerm] = useState(null);
  const [sortType, setSortType] = useState('End date (descending)');
  const [selectedPartner, setSelectedPartner] = useState(-1);

  const partners = useMemo(() => {
    return getPartnersFromLS();
  }, []);

  const [contracts, setContracts] = useState(
    sortAndFilterSiteContracts(
      siteContracts,
      sortType,
      selectedPartner,
      searchTerm,
    ),
  );

  useEffect(() => {
    setContracts(
      sortAndFilterSiteContracts(
        siteContracts,
        sortType,
        selectedPartner,
        searchTerm,
      ),
    );
  }, [siteContracts, searchTerm, sortType, selectedPartner]);

  return (
    <Stack spacing={2}>
      <Typography variant="h3">Site contracts</Typography>
      <Stack direction="row" spacing={1}>
        <TextField
          select
          value={sortType ?? ''}
          label="Sort by"
          size="medium"
          onChange={(e) => {
            setSortType(e.target.value);
          }}
          sx={{ minWidth: '150px' }}
          variant="standard"
        >
          {sortTypes.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          select
          value={selectedPartner ?? -1}
          label="By partner"
          size="medium"
          onChange={(e) => {
            setSelectedPartner(e.target.value);
          }}
          sx={{ minWidth: '150px' }}
          variant="standard"
        >
          <MenuItem key="key" value={-1}>
            All
          </MenuItem>
          {partners?.map((p) => (
            <MenuItem key={p.companyid} value={p.companyid}>
              {p.companyname}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Search"
          variant="standard"
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          value={searchTerm ?? ''}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: searchTerm && (
              <InputAdornment
                position="end"
                onClick={() => {
                  setSearchTerm('');
                }}
                sx={{
                  cursor: 'pointer',
                }}
              >
                <Cancel />
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Grid container spacing={1}>
        {Array.isArray(contracts) &&
          contracts.map((sc) => (
            <SiteContractItem
              key={`${sc.sitecontractid}-${sc.startdate}-${sc.enddate}-${sc.sitecontractname}`}
              siteContract={sc}
            />
          ))}
        {!Array.isArray(contracts) ||
          (contracts.length === 0 && (
            <Typography>No test contracts found</Typography>
          ))}
      </Grid>
    </Stack>
  );
};

export default SiteContractList;
